export default {
      id: "edit_notes-usage",
      viewBox: "0 0 15 16",
      url: __webpack_public_path__ + "img/icons.svg#edit_notes",
      toString: function () {
        return this.url;
      }
    }